import CalendarPickerComponent from "./CalendarPickerComponent";
import CalendarPickerRangeRhf from "./CalendarPickerRangeRhf";
import CalendarPickerSingleRhf from "./CalendarPickerSingleRhf";

type CalendarBaseProps = {
  maxDate?: Date;
  minDate?: Date;
  testID?: string;
};

export type CalendarPickerSingleRhfProps = {
  name: string;
  onChange?(): void;
  testID?: string;
};

export type CalendarPickerRangeRhfProps = {
  name: [string, string];
  onChange?(): void;
  testID?: string;
};

export type CalendarPickerComponentProps = {
  name?: undefined;
} & CalendarBaseProps &
  (SingleCalendarProps | RangeCalendarProps);

export type SingleCalendarProps = {
  value?: Date;
  onChange(value: Date): void;
};

export type RangeCalendarProps = {
  value: [Date | undefined, Date | undefined];
  onChange(value: [Date, Date | undefined]): void;
};

export type CalendarPickerProps = CalendarBaseProps &
  (
    | CalendarPickerSingleRhfProps
    | CalendarPickerRangeRhfProps
    | CalendarPickerComponentProps
  );

export default function CalendarPicker(props: CalendarPickerProps) {
  if (typeof props.name === "string") {
    return <CalendarPickerSingleRhf {...props} />;
  }

  if (props.name && Array.isArray(props.name)) {
    return <CalendarPickerRangeRhf {...props} />;
  }

  return (
    <CalendarPickerComponent {...(props as CalendarPickerComponentProps)} />
  );
}
